import axios from 'axios'
export default{
    data() {
        return {
            config:null,
        }
    },

    mounted() {
        // axios.get('testdata/page1.config.json').then(config=>{
        //     this.config = config.data;
        // })
    },
}